import '../../../../assets/css/bills.css'
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import Pagination from "react-js-pagination";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { delete_bill_from_db, getSupplier_contract_bills } from '../../../../services/supplier_service';

import State_details from '../state_details/state_details';
import Loading_animation_view from '../../../loading_animation_view/loading_animation_view';
import { download_bills_docs, notify_finance_service } from '../../../../services/for_allServices';
import Set_new_bill from '../set_new_bill/set_new_bill';
import swal from 'sweetalert';
import Contract_details from '../../contracts_list/contract_details/contract_details';
//import Contract_details from '../../../purchase_service/contracts_list/contract_details/contract_details';



function setState(bill_state, financeService_accord, purchaseService_accord, businessService_accord) {
    return (
        <>
            <Tooltip title="" placement="bottom" >
                <span style={{ marginLeft: '2%' }}>
                    {
                        financeService_accord === "0" || purchaseService_accord === "0" || businessService_accord === "0"
                            ? <Button className="status_deny" >{"refusée"}</Button>
                            : bill_state === "comptabilisée"
                                ? <Button className="status_success" >{bill_state}</Button>
                                : bill_state === "à valider" && (purchaseService_accord === null || businessService_accord === null)
                                    ? <Button className="status_success" >{bill_state}</Button>
                                    : bill_state === "mis en règlement"
                                        ? <Button className="status_success" >{bill_state}</Button>
                                        : bill_state === "réglée"
                                            ? <Button className="status_success" >{bill_state}</Button>
                                            : bill_state === "archivée"
                                                ? <Button className="status_success" >{bill_state}</Button>
                                                : <Button className="status_waiting" >{"en cours"}</Button>
                    }
                </span>
            </Tooltip>
        </>
    );
}


function verify_if_able_to_seeDetails(bill) {
    if (bill.bill_state === "à valider" || bill.bill_state === "refusée") return true;
    return false;
}

function verify_if_able_update(bills, all = false) {
    if (bills.length === 0 && all === true) return true;
    var able = false;
    bills.map((bill) => {
        if (bill.bill_state === null || bill.financeService_accord === "0" || bill.purchaseService_accord === "0" || bill.businessService_accord === "0") able = true;
    })
    return able;
}

function numberWithSpaces(x) {
    if (x) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    else return x;
}


function Bill_column({ bill, id, id2, delete_bill_from_the_list }) {

    const [view_state_details, setview_state_details] = useState(null);
    const [waiting, setWaiting] = useState(false);

    function download_billDocs(id_contract, bill_number, choice) {
        console.log(id_contract, bill_number, choice);

        const formData = new FormData();
        formData.append('id_contract', id_contract);
        formData.append('bill_number', bill_number);
        formData.append('choice', choice);
        download_bills_docs(formData).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            let file_extension = '';
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.includes('filename')) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    file_extension = matches[1].replace(/['"]/g, '').split(".")[1];
                }
            }
            fileLink.setAttribute('download', id_contract + "_" + "_" + choice + "_" + bill_number + "." + file_extension);
            document.body.appendChild(fileLink);
            fileLink.click();
        }).catch(err => {
            //console.log(err,err.response);
        });
    }

    function delete_bill(market_id, bill_id, id) {
        swal({
            title: "Êtes-vous sûr ?",
            text: "!!!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (isConfirm) => {
            if (isConfirm) {
                setWaiting(true);
                let formData = new FormData();
                formData.append("bill_id", bill_id);
                await delete_bill_from_db(formData).then((response) => {
                    console.log("message", response.data);
                    setWaiting(false);
                    swal("Supprimée !", "La facture a été supprimée avec succès.", "success");
                    delete_bill_from_the_list(market_id, id);
                }).catch((error) => {
                    console.error("Erreur lors de la suppression :", error.response);
                })
                setWaiting(false);
            }
        });
    }


    return (
        <div className='bill_container'>
            <div className='bill_infos_container'>
                <div className='bill_infos'>
                    <span className='download_bill_button' onClick={() => download_billDocs(bill.id_contract, bill.bill_number, "bill_content")} >
                        <Fab size="small" color="default" >
                            <DownloadIcon className="my_icon" />
                        </Fab>
                    </span>
                    <div className='bill_name'>
                        {bill.bill_number_value ?? "Facture N°" + bill.bill_number}
                        <Tooltip title="Supprimer">
                            <DeleteForeverIcon className={verify_if_able_update([bill]) ? "" : "disabled_button"} style={{ color: "#f33640f3", cursor: "pointer" }} onClick={() => delete_bill(id, bill.id, id2)} />
                        </Tooltip>
                    </div>
                </div>
                <div className='bill_amount'>
                    {
                        bill.amount_without_tax !== null
                            ? <>{bill.amount_without_tax + " MAD"}</>
                            : <span style={{ opacity: ".8" }} >non défini</span>
                    }
                </div>
                <div className='bill_treatedDate'>
                    {
                        bill.expiration_date !== null
                            ? (new Date(bill.expiration_date)).toLocaleString().split(/[,| ]/)[0]
                            : <span style={{ opacity: ".8" }} >non défini</span>
                    }
                </div>
                <div className='bill_treatedDate'>
                    {(new Date(bill.limit_date)).toLocaleString().split(/[,| ]/)[0]}
                </div>
                <div className='bill_state_container'>
                    <div className='bill_state'>{setState(bill.bill_state, bill.financeService_accord, bill.purchaseService_accord, bill.businessService_accord)}
                        {
                            verify_if_able_to_seeDetails(bill)
                                ? <div className="refuse_raison_button"
                                    onClick={() => setview_state_details(
                                        [
                                            [bill.financeService_refuse_reason, bill.purchaseService_refuse_reason, bill.businessService_refuse_reason],
                                            [bill.financeService_accord, bill.purchaseService_accord, bill.businessService_accord]
                                        ]
                                    )}>
                                    Details
                                </div>
                                : <div></div>
                        }
                    </div>

                </div>
            </div>

            <div className='bill_compDocs'>
                <div className='bill_compDoc'>
                    <span style={{ marginRight: '7px' }}  >
                        <Fab size="small" color="default" className={!bill.reception_pv ? "disabled_button" : ""} onClick={() => download_billDocs(bill.id_contract, bill.bill_number, "reception_pv")} >
                            <DownloadIcon className="my_icon" />
                        </Fab>
                    </span>
                    <span className='docs_name'>PV de réception</span>
                </div>
                <div className='bill_compDoc'>
                    <span style={{ marginRight: '7px' }} >
                        <Fab size="small" color="default" className={!bill.delivery_pv ? "disabled_button" : ""} onClick={() => download_billDocs(bill.id_contract, bill.bill_number, "delivery_pv")} >
                            <DownloadIcon className="my_icon" />
                        </Fab>
                    </span>
                    <span className='docs_name'>PV de livraison</span>
                </div>
            </div>
            {
                view_state_details !== null
                    ? <State_details view_state_details={view_state_details} setview_state_details={setview_state_details} />
                    : <></>
            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

function Markets_list({ markets, setOrder_newBill, notify_financeService, delete_bill_from_the_list }) {

    const [id_contract, setId_contract] = useState(null);

    function openContractDetails(id_contract) {
        console.log("submission:::::", id_contract);

        setId_contract(id_contract);
    }
    return (
        <>
            {
                markets.map((market, id) => (
                    <TableRow key={"market" + id}>
                        <TableCell align="left">{market.id_contract}
                            <br />
                            <Tooltip title="Visualiser les détails du contrat" placement="bottom">
                                <span style={{ marginRight: '6px' }}>
                                    <VisibilityIcon
                                        className="my_icon editIcon"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openContractDetails(market.id_contract);
                                        }}
                                    />
                                </span>
                            </Tooltip>
                        </TableCell>
                        <TableCell align="left">{market.service_fullName}</TableCell>
                        <TableCell align="left">
                            <div>
                                {
                                    (market.bills).length !== 0
                                        ? <>
                                            <div className='bill_container_titles'>
                                                <div className='bill_infos_container'>
                                                    <div className='bill_infos'>
                                                        <div className='bill_name'></div>
                                                    </div>
                                                    <div className='bill_amount'> Montant <br /> hors Tax</div>
                                                    <div className='bill_treatedDate'>Date <br /> d'échéance</div>
                                                    <div className='bill_treatedDate'>Date limite</div>

                                                    <div className='bill_state'>Status</div>
                                                </div>
                                                <div className='bill_compDocs'>
                                                    <span className='docs_name'>Docs complémentaires</span>
                                                </div>
                                            </div>
                                            {
                                                market.bills.map((bill, id2) => (
                                                    <Bill_column bill={bill} id={id} id2={id2} key={"market_bill" + id + id2} delete_bill_from_the_list={delete_bill_from_the_list} />
                                                ))
                                            }
                                        </>
                                        : <></>
                                }
                                <div className='add_bill_container'>
                                    {
                                        (market.bills).length == 0
                                            ? <span>Aucune facture déposée</span>
                                            : <span></span>
                                    }
                                    <div>
                                        <Tooltip title="Déposer une facture" placement="bottom">
                                            <span className={verify_if_able_update(market.bills, true) ? "add_button" : "add_button"} onClick={() => setOrder_newBill(market, id)}>
                                                Déposer une facture
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="Notifier le service de finance" placement="bottom">
                                            <span className={(market.bills).length != 0 ? "add_button" : "add_button disabled_button"} style={{ marginLeft: "10px" }} onClick={() => notify_financeService(market)}>
                                                Notifier
                                            </span>
                                        </Tooltip>
                                    </div>

                                </div>
                            </div>
                        </TableCell>
                    </TableRow>
                ))
            }
            {id_contract != null
                ? <Contract_details id_contract={id_contract} setId_contract={setId_contract} /> : <></>}
        </>
    );
}


function Contracts_bills({ filter_bills_src, setUrl_updated, url_updated }) {

    let supplier = JSON.parse(localStorage.getItem('user-info'))
    let history = useHistory();
    const contract = "contract";

    const [markets, setMarkets] = useState(null);

    const [add_bill, setAdd_bill] = useState(null);
    const [chosenSubmission, setChosenSubmission] = useState(null);

    const [search_value, setsearch_value] = useState("");
    const [search_filter, setsearch_filter] = useState('all');

    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setdataPerPage] = useState(5);
    const [data_count, setdata_count] = useState(0);

    const [waiting, setWaiting] = useState(false);


    useEffect(() => {
        setMarkets(null);
        setdata_count(0);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var tmp_searchFilter = "all";
        var tmp_searchValue = null;
        async function load_data() {
            if (urlParams.get('filtre')) {
                tmp_searchFilter = urlParams.get('filtre');
            } if (urlParams.get('valeur')) {
                tmp_searchValue = urlParams.get('valeur');
            }

            await setsearch_filter(tmp_searchFilter);
            await setsearch_value(tmp_searchValue);

            let page = (urlParams.get('page') ? urlParams.get('page') : 1);
            await setCurrentPage(page)
            let formData = new FormData();
            formData.append("id_supplier", supplier.id);
            await getSupplier_contract_bills(formData, tmp_searchFilter, tmp_searchValue, page).then((response) => {
                setdata_count(response.data.total);
                setMarkets(response.data.data);
                console.log("contracts stand", response.data.data);
            }).catch(err => {
                //console.log(err,err.response);
            });


        }
        load_data();
    }, [url_updated]);



    function search() {
        let path = history.location.pathname;
        history.push(path + "?src=" + filter_bills_src + "&filtre=" + search_filter + "&valeur=" + search_value);
        setUrl_updated(search_value);
    }


    function set__filter(value) {
        if (value === "all") {
            setsearch_filter(value);
            let path = history.location.pathname;
            history.push(path + "?src=" + filter_bills_src + "&filtre=" + value);
            setUrl_updated(value);
        } else setsearch_filter(value);
    }


    function set_bills_src(value) {
        let path = history.location.pathname;
        history.push(path + "?src=" + value);
        setUrl_updated(value);
    }


    function notify_financeService(order_infos) {
        console.log(order_infos);
        setWaiting(true);
        let formData = new FormData();
        formData.append("id_contract", order_infos.id_contract);
        notify_finance_service(formData).then((response) => {
            //console.log(response.data);
            setWaiting(false);
            swal("Le service sera bientôt notifié !", {
                icon: "success",
            });
        }).catch((error) => {
            setWaiting(false);
            //console.log(error.response);
        })
    }


    function setOrder_newBill(order_infos, id_list) {
        setChosenSubmission(order_infos);
        setAdd_bill(id_list);
    }

    function submit_new_bills(newBills, id) {
        let tmp_array = [...markets];
        tmp_array[id].bills = newBills;
        setMarkets(tmp_array);
    }

    function delete_bill_from_the_list(market_id, bill_id) {
        console.log(market_id);
        let tmp_array = [...markets];
        tmp_array[market_id].bills.splice(bill_id, 1);
        setMarkets(tmp_array);
    }



    async function change_page(page) {
        await setCurrentPage(page);
        let path = history.location.pathname;
        let params = history.location.search;
        let search_params = params.split('&');
        let tmp_params = path;
        if (!params) history.push(path + "?page=" + page);
        else {
            for (let i in search_params) {
                if (search_params[i].includes("page=")) {
                    if (i == 0) tmp_params = tmp_params + "?page=" + page;
                    else tmp_params = tmp_params + "&page=" + page;
                } else {
                    if (i == 0) tmp_params = tmp_params + search_params[i];
                    else tmp_params = tmp_params + "&" + search_params[i];
                }
            }
            if (!tmp_params.includes("page=")) tmp_params = tmp_params + "&page=" + page;
            history.push(tmp_params);
        }
        await setUrl_updated(page);
    }

    return (
        <>
            {
                markets == null
                    ? <Loading_animation_view />
                    : <div className='purchase_bills_container'>
                        <div className='bills_src_header'>
                            <FormControl variant="standard" className="header_form" >
                                <InputLabel id="demo-simple-select-helper-label">Factures/paiement</InputLabel>
                                <Select required value={filter_bills_src}
                                    onChange={e => { set_bills_src(e.target.value) }} >
                                    {/* <MenuItem value={"marchés"} >{"Marchés"}</MenuItem> */}
                                    <MenuItem value={"commandes"} >{"Bons de commande"}</MenuItem>
                                    <MenuItem value={"contract"} >{"Contrats"}</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className='three_forms_header_container'>
                            <div className='page_title'>Contracts</div>
                            <div className='search_filter_container'>
                                <FormControl variant='standard' className="header_form" >
                                    <InputLabel id="demo-simple-select-helper-label">Filtre</InputLabel>
                                    <Select value={search_filter} onChange={(e) => { set__filter(e.target.value) }}>
                                        <MenuItem value="all">Aucun</MenuItem>
                                        <MenuItem value="service">Nom du Service</MenuItem>
                                    </Select>
                                </FormControl>

                                <Grid container spacing={1} alignItems="flex-start" className={search_filter === "all" ? "search_bar disabled_button" : "search_bar"} >
                                    <Grid item>
                                        <SearchIcon onClick={search} className={search_value === "" ? "disabled_button my_icon" : "my_icon"} style={{ cursor: "pointer" }} />
                                    </Grid>
                                    <Grid>
                                        <TextField variant='standard' label="Chercher" value={search_value} onChange={(e) => { setsearch_value(e.target.value) }} />
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                        <div className="bills_table_container">
                            <TableContainer className="bills_table">
                                <Table aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Code de contract</TableCell>
                                            <TableCell>Service d'achat</TableCell>
                                            <TableCell>Factures</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            markets.length !== 0
                                                ? <Markets_list markets={markets} setOrder_newBill={setOrder_newBill} notify_financeService={notify_financeService} delete_bill_from_the_list={delete_bill_from_the_list} />
                                                : <div style={{ margin: "10px", fontSize: ".8rem", width: '100%', textAlign: "center", alignContent: "center" }}>Aucune facture disponible</div>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        {
                            markets.length !== 0
                                ? <div className="pagination_container">
                                    <Pagination
                                        activePage={Number(currentPage)}
                                        itemsCountPerPage={dataPerPage}
                                        totalItemsCount={Number(data_count)}
                                        pageRangeDisplayed={4}
                                        onChange={change_page.bind(this)}
                                    />
                                </div>
                                : <></>
                        }
                    </div>
            }
            {
                add_bill != null
                    ? <Set_new_bill add_bill={add_bill} setAdd_bill={setAdd_bill} order_infos={chosenSubmission} submit_new_bills={submit_new_bills} contract={contract} id_supplier={supplier.id} />
                    : <></>
            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default Contracts_bills;
